import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { ChartConfig } from '../Chart';
import { ChartEditor } from './ChartEditor';

interface ChartModalProps {
  isOpen: boolean;
  onClose: () => void;
  config: ChartConfig;
  onSave: (config: ChartConfig, imagePath?: string) => void;
}

export const ChartModal: React.FC<ChartModalProps> = ({
  isOpen,
  onClose,
  config,
  onSave,
}) => {
  const handleSave = (newConfig: ChartConfig, imagePath?: string) => {
    onSave(newConfig, imagePath);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      isCentered={false}
      scrollBehavior="inside"
      motionPreset="slideInBottom"
      portalProps={{ appendToParentPortal: false }}
    >
      <ModalOverlay
        bg="blackAlpha.600"
        backdropFilter="blur(2px)"
        data-chart-modal="true"
      />
      <ModalContent
        maxW="95vw"
        maxH="95vh"
        w="1600px"
        m="auto"
        borderRadius="16px"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        data-chart-modal="true"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
      >
        <ModalCloseButton top="20px" right="20px" />
        <ModalBody
          p="30px 80px"
          flex="1"
          display="flex"
          flexDirection="column"
          overflowY="auto"
          overflowX="hidden"
          data-chart-modal="true"
        >
          <ChartEditor
            config={config}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChartModal;
